import { useEffect } from "react";
import { paths } from "../i18n/paths";
import { useI18n } from "../i18n/I18nProvider";

/**
 * Frames 5:2 and 180:3 place the logos on the left and the project name plus CTA
 * on the right in both locales, so the row is direction-independent. Only the
 * text inside each block follows the locale direction.
 */
export function Header() {
  const { locale, copy, direction } = useI18n();

  useEffect(() => {
    const goToForm = (event: Event) => {
      const anchor = (event.target as HTMLElement).closest("[data-scroll-to-form]");
      if (!anchor) return;
      const form = document.getElementById("lead-form");
      if (form) {
        event.preventDefault();
        form.scrollIntoView({ block: "start" });
      }
    };
    document.addEventListener("click", goToForm);
    return () => document.removeEventListener("click", goToForm);
  }, []);

  return (
    <header className="sticky top-0 z-40 border-b border-line-2 bg-white">
      <div
        dir="ltr"
        data-reveal-load="header"
        className="flex h-[72px] items-center justify-between mx-auto w-full max-w-[1440px] px-[18px] lg:px-[72px] lg:h-[88px]"
      >
        <div className="flex items-center gap-[18px]">
          <a href={paths[locale].home} className="inline-flex items-center" aria-label="bond">
            <img
              src="/logos/logo-bond.png"
              alt="bond"
              width={130}
              height={42}
              className="h-[30px] w-auto lg:h-[42px]"
            />
          </a>
          <img
            src="/logos/logo-tdco.png"
            alt="TDCO, Technical Dimensions Co."
            width={155}
            height={34}
            className="hidden h-[34px] w-auto lg:block"
          />
        </div>
        <div className="flex items-center gap-3" dir={direction}>
          <span className="text-[15px] font-bold text-navy lg:text-[20px]">
            {copy.brand.projectName}
          </span>
          <a
            href="#lead-form"
            data-scroll-to-form
            className="hidden rounded-xl bg-navy px-[18px] py-2.5 text-[13px] font-semibold leading-[24px] text-white lg:block"
          >
            {copy.header.cta}
          </a>
        </div>
      </div>
    </header>
  );
}
